<template>
    <div>
        <notifications
            class="o-notifications-api"
            :duration="1000"
            :width="280"
            position="bottom right"
            group="api-info"
        >
            <template
                slot="body"
                slot-scope="{
                    item: {
                        data: { name, message, code, text, title, type },
                    },
                }"
            >
                <div
                    class="vue-notification-template vue-notification"
                    :class="type"
                >
                    <div class="title">
                        <strong v-if="type === 'error'">Request Error</strong>
                        <span v-else class="title">
                            {{ title }}
                        </span>
                    </div>
                    <span v-if="type === 'error'">
                        <strong>{{ name }}</strong> <br />
                        <strong>{{ message }}</strong> <br />
                        <strong>{{ code }}</strong>
                    </span>
                    <span v-else class="text"> {{ text }} </span>
                </div>
            </template>
        </notifications>
    </div>
</template>

<script>
import { notificationsComputed } from '@state/helpers'

export default {
    name: 'ONotificationsApi',
    computed: {
        ...notificationsComputed,
    },
    watch: {
        error: {
            handler({ data, duration = 1000 }) {
                if (!data) return

                this.$notify({
                    // Name of the notification holder
                    group: 'api-info',
                    // Class that will be assigned to the notification
                    type: 'error',
                    data: {
                        ...data,
                        type: 'error',
                    },
                    duration,
                })
            },
            deep: true,
        },
        info: {
            handler({ title, text }) {
                this.$notify({
                    // Name of the notification holder
                    group: 'api-info',
                    // Class that will be assigned to the notification
                    type: 'info',
                    data: {
                        title,
                        text,
                        type: 'info',
                    },
                })
            },
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'theme';
</style>
